import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SupportPopupMainComponent } from './support-popup-main/support-popup-main.component';
import { SupportArticlePopupComponent } from './support-article-popup/support-article-popup.component';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { TranslateModule } from '@ngx-translate/core';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SupportContactusPopupComponent } from './support-contactus-popup/support-contactus-popup.component';

@NgModule({
  declarations: [SupportPopupMainComponent, SupportArticlePopupComponent, SafeUrlPipe, SupportContactusPopupComponent],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
  providers: [TranslateHandler],
  exports: [SupportPopupMainComponent, SupportArticlePopupComponent, SafeUrlPipe]
})
export class SupportPopupModule { }
